import React from 'react';

const PreviewBanner = () => (
  <div className="flex h-16 w-full items-center justify-center border-b-2 border-t-2 border-new-gray-1/25 bg-new-gray-2">
    <p className="font-medium text-base uppercase text-new-gray-1">
      Preview: this page is not live
    </p>
  </div>
);

export default PreviewBanner;
